<div class="booking-container__image">
  <img [src]="'assets/icon/booking-confirmation-' + step + '.svg'" />
  <div class="booking-container__image-tooltip-container">
    <div class="booking-container__image-tooltip" [matTooltip]="'BookingConfirmation.Tooltip.ReceivedAppointment' | translate"></div>
    <div class="booking-container__image-tooltip" [matTooltip]="'BookingConfirmation.Tooltip.AccountConfirmation' | translate"></div>
    <div class="booking-container__image-tooltip" [matTooltip]="'BookingConfirmation.Tooltip.AccountCreated' | translate"></div>
  </div>
</div>
